<div class="flex flex-col gap-4 items-end">
  <matrix-filter-bar [filtersConfig]="filtersConfig()" (applyFilters)="onApplyFilters($event)" ></matrix-filter-bar>
</div>
